// Import Custom Conponents
//import ThreeJSObjectExpolorer from "./components/ThreeJSObectExlorer";
// import DarkMode from "./components/DarkMode";
// import StickyHeader from "./components/StickyHeader";
// import DismissibleBanner from "./components/DismissibleBanner";
import ChartToggle from "./components/ChartToggle";
import Map from "./components/Map";
// import EasyPageTransitions from "./components/EasyPageTransitions";
// import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
// import HorizontalScrollComponent from "./components/HorizontalScrollComponent"
import ParallaxComponent from "./components/ParallaxComponent"
// import ImageCopySpread from "./components/ImageCopySpread"
//import Slideshow from "./components/Slideshow";
import ImageDrawer from "./components/ImageDrawer";
import ScrollViewport from "./components/ScrollViewport";
// import AdvancedGallery from "./components/AdvancedGallery"
// import TabsAndTable from "./components/TabsAndTable"

// Initialise our components on jQuery.ready…

jQuery(function ($) {

  //ThreeJSObectExlorer 
  //ThreeJSObjectExpolorer();

  // DarkMode.
  // DarkMode.init();

  ImageDrawer.init();
  Map.init();
  ScrollViewport.init();

  // // DismissibleBanner
  // DismissibleBanner.init();

  // // Toggle Menu interaction
  //Hamburger.init();

  // // Replace and hide email address
  // ReplaceObfuscatedEmailAddresses.init();

  // // prevent default anchor click for fadein fadeout page transitions
  // EasyPageTransitions.init();

  // // Scrolling component for multi horizintal list
  // HorizontalScrollComponent.init();

  // // ChartToggle component
  ChartToggle.init();

  //ParallaxComponent.init();
  ParallaxComponent.init();

  // // Animate on scroll into view elements
  // ImageCopySpread.init();

  // // Slick slider
  //Slideshow.init();

  // // Slick Slider with interaction
  // AdvancedGallery.init();

  // // Tabs And Table Control
  // TabsAndTable.init();
  
  // Auto scroll when learn more from heros
  $('.left-menu a').on('click', function(e){
    //e.preventDefault();
    var gotoid = $(this).attr('href');
    $("html, body").animate({ 
      scrollTop: $(gotoid).offset().top - 120
    }, {
      duration: 1000,
      specialEasing: {
        scrollTop: "easeOutCirc"
      }
    });
  });

  $('.show-more').on('click', () => {
    $('.show-more').html('Show Less');
    $('.mini-news-list').toggleClass('show_more');
  });

});


;(function(){
  function id(v){ return document.getElementById(v); }
  function section(v){ return document.getElementsByClassName(v); }
  function topConent(v){ return document.getElementsByClassName(v); }
  function loadbar() {
    var ovrl = id("loader"),
        prog = id("progress"),
        page = id("page"),
        sections = section("preload"),
        top = topConent("bg"),
        img = document.images,
        c = 0,
        tot = img.length;
    if(tot == 0) return doneLoading();
    function imgLoaded(){
      c += 1;
      var perc = ((100/tot*c) << 0) +"%";
      prog.style.width = perc;
      //stat.innerHTML = "Loading "+ perc;
      if(c===tot) return doneLoading();
    }
    function doneLoading(){
      ovrl.classList.add('hide');
      page.classList.add('active');
      for (var i = 0; i < sections.length; i++) {
        sections[i].classList.add('active');
      }
      for(var i = 0; i < top.length; i++){  
        let _top = top[i];        
        let img = _top.dataset.img;
        _top.classList.add('active');
        _top.style.backgroundImage = 'url('+img+')';
        // setTimeout(function(){
        // }, 500*(1+1));
      }
    }
    for(var i=0; i<tot; i++) {
      var tImg     = new Image();
      tImg.onload  = imgLoaded;
      tImg.onerror = imgLoaded;
      tImg.src     = img[i].src;
    }    
    window.addEventListener('resize', doneLoading);
    window.onorientationchange = function() {
      doneLoading();
    }   
  }
  document.addEventListener('DOMContentLoaded', loadbar, false);

}());



